const Title = {
    elemName: '題',
    type: 'inline',
    doc: '書状や転籍などの題をマークアップします。',
    example: '《題：地震年代記》',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '{{$1}}',
    htmlTemplate: `<h1 class="Title {{$classes}}" {{$htmlId}}>{{{$1}}}</h1>`,
    xmlTemplate: `<docTitle {{{$xmlId}}} {{{$xmlSubtypes}}}>{{{$1}}}</docTitle>`,
    docxTemplate: `<w:r>
                <w:rPr>
                <w:sz w:val="28"/>
                <w:szCs w:val="32"/>
                </w:rPr>
                <w:t>{{{$$1}}}</w:t>
                </w:r>`,
    latexTemplate: '{{{$1}}}',
};
export default Title;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGl0bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2lubGluZV9ydWxlcy9UaXRsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLEtBQUssR0FBbUI7SUFDNUIsUUFBUSxFQUFFLEdBQUc7SUFDYixJQUFJLEVBQUUsUUFBUTtJQUNkLEdBQUcsRUFBRSxzQkFBc0I7SUFDM0IsT0FBTyxFQUFFLFdBQVc7SUFDcEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsWUFBWSxFQUFFLFFBQVE7SUFDdEIsWUFBWSxFQUFFLDBEQUEwRDtJQUN4RSxXQUFXLEVBQUUsK0RBQStEO0lBQzVFLFlBQVksRUFBRTs7Ozs7O3VCQU1PO0lBQ3JCLGFBQWEsRUFBRSxVQUFVO0NBQzFCLENBQUM7QUFFRixlQUFlLEtBQUssQ0FBQyJ9